import React, { Fragment, useState, useCallback, useEffect } from "react";

import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import Request from "core/requests";
import { Loading } from "components/common";
import { Grid } from "@mui/material";
import ActiveSensorsContainer from "./ActiveSensors.container";
import AllarmSensorsContainer from "./AllarmSensors.container";
import WarningSensorsContainer from "./WarningSensors.container";
import { saveCluster, saveSearch } from "store/user.store";
import { useNavigate } from "react-router-dom";
import { openSnackbar } from "store/slices/snackbar";
import { refreshToken, logout } from "store/user.store";
import ToolbarTableComponent from "components/tables/toolbar/ToolbarTable.component";
import { useTranslation } from "react-i18next";


const optionsChecked = {
  GATEWAY: false,
  ENVSENSOR: false,
  CAMERA: false,
  PCOUNTER: false,
  WIFI: false,
};
const StatusSensorsListContainer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token, cluster, refresh_token, user, search } = useSelector(
    (state) => state.user
  );
  const [statusStations, setStatusStations] = useState(null);
  const [listClusters, setListClusters] = useState([]);
  const [zoneSelected, setZoneSelected] = useState(cluster ? cluster : []);
  const [loading, setLoading] = useState(true);
  const [loadingZone, setLoadingZone] = useState(true);

  const [values, setValues] = useState(null);
  const [stationsCritic, setStationsCritic] = useState(null);
  const [stationsOk, setStationsOk] = useState(null);
  const [stationsWarning, setStationsWarning] = useState(null);
  const [stationsCriticFilter, setStationsCriticFilter] = useState(null);
  const [stationsOkFilter, setStationsOkFilter] = useState(null);
  const [stationsWarningFilter, setStationsWarningFilter] = useState(null);
  const [checked, setChecked] = useState(optionsChecked);
  const [allStations, setAllStations] = useState(null);
  const [isFirstRefresh, setIsFirstRefresh] = useState(true);
  const [valueSearch, setValueSearch] = useState("");
  const [role, setRole] = useState(null)
  const [refresh, setRefresh] = useState(false);

  const onClickFilter = useCallback(
    (item) => {
      setChecked({ ...checked, [item]: !checked[item] });
    },
    [checked]
  );

  const handleSearchTable = useCallback(
    (e) => {
      const searchValue = e.target.value;
      setValueSearch(searchValue);

      const filterCritic = stationsCritic?.filter(
        (item) =>
          item.stationId?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.tag?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.alias?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.address?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.cluster?.toLowerCase().includes(searchValue.toLowerCase())
      );
      const filterOk = stationsOk?.filter(
        (item) =>
          item.stationId?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.tag?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.alias?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.address?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.cluster?.toLowerCase().includes(searchValue.toLowerCase())
      );

      const filterWarning = stationsWarning?.filter(
        (item) =>
          item.stationId?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.tag?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.alias?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.address?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.cluster?.toLowerCase().includes(searchValue.toLowerCase())
      );
      setStationsCriticFilter(filterCritic);
      setStationsOkFilter(filterOk);
      setStationsWarningFilter(filterWarning);
      if (search) {
        dispatch(saveSearch(null))
      }
    },
    // eslint-disable-next-line
    [stationsWarning, stationsOk, stationsCritic, search]
  );

  const handleChangeZone = useCallback((item) => {
    setValueSearch('');
    setZoneSelected(item);
    dispatch(saveCluster(item));

    setLoading(true);
    setValues(null);
    setStationsCritic(null);
    setStationsOk(null);
    setStationsWarning(null);
    // eslint-disable-next-line
  }, []);

  const onClickAlert = useCallback((item) => {
    dispatch(saveSearch(item));
    navigate("/dashboard/warning-list");
    // eslint-disable-next-line
  }, []);

  const onFailure = useCallback((error) => {
    dispatch(
      openSnackbar({
        open: true,
        message: error.response?.data?.message ? error.response.data.message : "Errore",

        variant: "alert",
        alert: {
          color: "error",
        },
        close: false,
      })
    );
    // eslint-disable-next-line
  }, []);

  const onError = useCallback(
    (error) => {
      if (isFirstRefresh) {
        setLoading(false);
        if (error?.response?.status === 403) {
          dispatch(logout());
        } else {
          if (error?.response?.status !== 401) {
            onFailure(error);
          } else {
            if (isFirstRefresh) {
              dispatch(
                refreshToken({
                  grant_type: "refresh_token",
                  refresh_token: user.refresh_token,
                })
              );
              setIsFirstRefresh(false);
            }
          }
        }
      } else {
        onLogout(error);
      }
    },
    // eslint-disable-next-line
    []
  );
  const onLogout = useCallback((error) => {
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      dispatch(logout());
    }
    // eslint-disable-next-line
  }, []);


  useEffect(() => {
    if (user) {
      setRole(user?.role)
    }
  }, [user]);


  useEffect(() => {
    setLoadingZone(true);
    Request.stations
      .allPoi({
        token: token,
      })
      .then((resp) => {
        setAllStations(resp);
        setLoadingZone(false);
        setIsFirstRefresh(true);
      })
      .catch((error) => onError(error));
    // eslint-disable-next-line
  }, [token, refresh_token, refresh]);

  useEffect(() => {
    const envPath = checked["ENVSENSOR"] ? "&env_monitoring=true" : "";
    setLoading(true);
    Request.stations
      .getStatus({
        cluster: !_.isEmpty(zoneSelected) ? `cluster=${zoneSelected}&` : "",
        token: token,
        camera: checked["CAMERA"] ? true : "None",
        gateway: checked["GATEWAY"] ? true : "None",
        people_counter: checked["PCOUNTER"] ? true : "None",
        wifi: checked["WIFI"] ? true : "None",
        envPath: envPath,
      })
      .then((resp) => {
        setStatusStations(resp);
        //setLoading(false);
        setIsFirstRefresh(true);
      })
      .catch((error) => onError(error));
    Request.stations
      .all({
        token: token,
        cluster: !_.isEmpty(zoneSelected) ? `cluster=${zoneSelected}&` : "",
        camera: checked["CAMERA"] ? true : "None",
        gateway: checked["GATEWAY"] ? true : "None",
        people_counter: checked["PCOUNTER"] ? true : "None",
        wifi: checked["WIFI"] ? true : "None",
        envPath: envPath,
      })
      .then((resp) => {
        setValues(resp);
        //setLoading(false);
        setIsFirstRefresh(true);
      })
      .catch((error) => onError(error));
    // eslint-disable-next-line
  }, [zoneSelected, token, checked, refresh_token, refresh]);


  useEffect(() => {
    //Ottengo dalla lista delle stazioni i cluster esistenti
    if (allStations && !_.isEmpty(allStations?.stations)) {
      const clusters = allStations?.stations?.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t?.cluster === value?.cluster)
      );
      const list = clusters.map((item) => {
        return item["cluster"];
      });

      setListClusters(list.sort());
    }
  }, [allStations]);

  useEffect(() => {
    if (
      statusStations &&
      statusStations.stations &&
      values &&
      values.stations
    ) {
      const critcs = [];
      const warnings = [];
      const ok = [];

      statusStations?.stations.map((station) => {
        if (
          _.includes(Object.values(station), 40) ||
          _.includes(Object.values(station), -1)
        ) {
          critcs.push(
            Object.assign(
              station,
              _.find(
                values?.stations,
                (item) => item?.stationId === station?.stationId
              )
            )
          );
          return critcs;
        } else {
          if (_.includes(Object.values(station), 30)) {
            return warnings.push(
              Object.assign(
                station,
                _.find(
                  values?.stations,
                  (item) => item?.stationId === station?.stationId
                )
              )
            );
          } else {
            return ok.push(
              Object.assign(
                station,
                _.find(
                  values?.stations,
                  (item) => item?.stationId === station?.stationId
                )
              )
            );
          }
        }
      });

      setStationsCritic(critcs);
      setStationsWarning(warnings);
      setStationsOk(ok);
      if (search) {
        setValueSearch(search)
        dispatch(saveSearch(null));
      } else {
        setStationsCriticFilter(critcs);
        setStationsWarningFilter(warnings);
        setStationsOkFilter(ok);
      }

      setLoading(false)
    }
    // eslint-disable-next-line
  }, [statusStations, values, search]);

  useEffect(() => {
    if (valueSearch) {
      handleSearchTable({ target: { value: valueSearch } })
    }
  }, [valueSearch, handleSearchTable])

  const onRefresh = useCallback(() => {
    setRefresh(!refresh);
  }, [refresh]);

  return (
    <Fragment>
      {loadingZone ? (
        <Loading />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ToolbarTableComponent
              listClusters={listClusters}
              handleChangeZone={handleChangeZone}
              loading={loadingZone}
              zoneSelected={zoneSelected}
              handleSearch={handleSearchTable}
              checked={checked}
              onClickFilter={onClickFilter}
              labelSearch={t("Search")}
              valueSearch={valueSearch}
              onRefresh={onRefresh}
            />
          </Grid>

          <Grid item container spacing={2}>
            <Grid item xs={12}>
              <AllarmSensorsContainer
                onClick={onClickAlert}
                values={stationsCriticFilter}
                isLoading={loading}
                userRole={role}
              />
            </Grid>

            <Grid item xs={12}>
              <WarningSensorsContainer
                onClick={onClickAlert}
                values={stationsWarningFilter}
                isLoading={loading}
                userRole={role}

              />
            </Grid>

            <Grid item xs={12}>
              <ActiveSensorsContainer
                onClick={onClickAlert}
                values={stationsOkFilter}
                isLoading={loading}
                userRole={role}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Fragment>
  );
};

export default StatusSensorsListContainer;
